var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5805_191520)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.3484 113.487C63.6837 113.487 63.1461 112.947 63.1461 112.28C63.1461 111.612 63.6837 111.073 64.3484 111.073H64.5854V106.651H64.3484C63.6837 106.651 63.1461 106.112 63.1461 105.444C63.1461 104.777 63.6837 104.237 64.3484 104.237H64.5854V99.816H64.3484C63.6837 99.816 63.1461 99.2763 63.1461 98.609C63.1461 97.9418 63.6837 97.4021 64.3484 97.4021H64.5854V90.7003C64.5854 88.71 62.9784 87.0969 60.9957 87.0969H49.7641C47.7814 87.0969 46.1744 88.71 46.1744 90.7003V100.872H46.4634C47.1282 100.872 47.6658 101.412 47.6658 102.079C47.6658 102.746 47.1282 103.286 46.4634 103.286H46.1744V107.707H46.4634C47.1282 107.707 47.6658 108.247 47.6658 108.914C47.6658 109.582 47.1282 110.121 46.4634 110.121H46.1744V114.543H46.4634C47.1282 114.543 47.6658 115.082 47.6658 115.75C47.6658 116.37 47.1975 116.875 46.5964 116.939C47.2033 118.076 48.3941 118.848 49.7641 118.848H60.9957C62.9784 118.848 64.5854 117.235 64.5854 115.245V113.487H64.3484Z",
    fill: "url(#paint0_linear_5805_191520)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5805_191520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 87,
    width: 19,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3484 113.487C63.6837 113.487 63.1461 112.947 63.1461 112.28C63.1461 111.612 63.6837 111.073 64.3484 111.073H64.5854V106.651H64.3484C63.6837 106.651 63.1461 106.112 63.1461 105.444C63.1461 104.777 63.6837 104.237 64.3484 104.237H64.5854V99.816H64.3484C63.6837 99.816 63.1461 99.2763 63.1461 98.609C63.1461 97.9418 63.6837 97.4021 64.3484 97.4021H64.5854V90.7003C64.5854 88.71 62.9784 87.0969 60.9957 87.0969H49.7641C47.7814 87.0969 46.1744 88.71 46.1744 90.7003V100.872H46.4634C47.1282 100.872 47.6658 101.412 47.6658 102.079C47.6658 102.746 47.1282 103.286 46.4634 103.286H46.1744V107.707H46.4634C47.1282 107.707 47.6658 108.247 47.6658 108.914C47.6658 109.582 47.1282 110.121 46.4634 110.121H46.1744V114.543H46.4634C47.1282 114.543 47.6658 115.082 47.6658 115.75C47.6658 116.37 47.1975 116.875 46.5964 116.939C47.2033 118.076 48.3941 118.848 49.7641 118.848H60.9957C62.9784 118.848 64.5854 117.235 64.5854 115.245V113.487H64.3484Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5805_191520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7584 100.884H42.4633C41.8248 100.884 41.3072 101.403 41.3072 102.044V102.131C41.3072 102.772 41.8248 103.292 42.4633 103.292H51.7584C52.3969 103.292 52.9145 102.772 52.9145 102.131V102.044C52.9145 101.403 52.3969 100.884 51.7584 100.884Z",
    fill: "url(#paint1_linear_5805_191520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7179 110.127H42.5095C41.8447 110.127 41.3072 109.587 41.3072 108.92C41.3072 108.253 41.8447 107.713 42.5095 107.713H51.7179C52.3827 107.713 52.9203 108.253 52.9203 108.92C52.9203 109.587 52.3827 110.127 51.7179 110.127Z",
    fill: "url(#paint2_linear_5805_191520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9729 97.4196H58.6778C58.0393 97.4196 57.5217 97.9391 57.5217 98.5801V98.6671C57.5217 99.308 58.0393 99.8276 58.6778 99.8276H67.9729C68.6115 99.8276 69.1291 99.308 69.1291 98.6671V98.5801C69.1291 97.9391 68.6115 97.4196 67.9729 97.4196Z",
    fill: "url(#paint3_linear_5805_191520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9266 106.657H58.7182C58.0534 106.657 57.5158 106.117 57.5158 105.45C57.5158 104.783 58.0534 104.243 58.7182 104.243H67.9266C68.5914 104.243 69.129 104.783 69.129 105.45C69.129 106.117 68.5914 106.657 67.9266 106.657Z",
    fill: "url(#paint4_linear_5805_191520)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7771 59.6163H21.7862C21.7862 59.6163 21.1619 70.5424 29.0755 76.1534C42.1685 86.3483 46.2091 94.8315 46.2091 94.8315H64.5219C64.5219 94.8315 68.389 86.3483 81.482 76.1534C89.3956 70.5424 88.7713 59.6163 88.7713 59.6163H88.7771Z",
    fill: "url(#paint5_linear_5805_191520)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9776 8H39.0354C40.7927 8 42.2147 9.42741 42.2147 11.1914V47.9384H34.7983V11.1914C34.7983 9.42741 36.2203 8 37.9776 8Z",
    fill: "url(#paint6_linear_5805_191520)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5684 8H73.6262C75.3835 8 76.8055 9.42741 76.8055 11.1914V47.9384H69.3891V11.1914C69.3891 9.42741 70.8111 8 72.5684 8Z",
    fill: "url(#paint7_linear_5805_191520)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2147 28.5988H34.7983V47.9384H42.2147V28.5988Z",
    fill: "url(#paint8_linear_5805_191520)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8287 28.5988H69.4122V47.9384H76.8287V28.5988Z",
    fill: "url(#paint9_linear_5805_191520)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2711 41.1504H21.5696V59.419H89.2711V41.1504Z",
    fill: "url(#paint10_linear_5805_191520)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5049 11.2239H58.5749C59.2731 11.2239 59.841 11.7519 59.841 12.4011V41.3183H51.2388V12.4011C51.2388 11.7519 51.8067 11.2239 52.5049 11.2239Z",
    fill: "url(#paint11_linear_5805_191520)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5805_191520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 60,
    width: 68,
    height: 36
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2259 78.8458C36.4746 81.1435 39.0238 83.7663 40.8505 86.3542C42.2899 88.3966 43.2783 90.4101 43.8044 92.2147C44.2899 93.8858 46.4519 95.0057 48.5155 95.0057H63.0652C64.7935 95.0057 66.3543 93.8858 66.8399 92.2147C67.285 90.677 68.0653 88.9885 69.181 87.2594C71.0308 84.3871 73.7881 81.4105 77.4183 78.8458C78.0252 78.4164 78.6553 77.9986 79.3143 77.5924C80.8866 76.6234 82.1988 75.4397 83.2971 74.1458C85.1758 71.935 86.4186 69.4225 87.2337 67.1712C88.5169 63.6375 88.7597 60.7653 88.7597 60.7653H21.8903C21.8903 60.7653 22.1273 63.6375 23.4163 67.1712C24.2372 69.4225 25.48 71.935 27.3529 74.1458C28.4512 75.4397 29.7634 76.6234 31.3357 77.5924C31.9947 77.9986 32.6248 78.4164 33.2317 78.8458H33.2259Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5805_191520)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M95.8814 59.2218H19V68.0706H95.8814V59.2218Z",
    fill: "url(#paint12_linear_5805_191520)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M51.6592 41.1504H35.5398V58.3444H51.6592V41.1504Z",
    fill: "url(#paint13_linear_5805_191520)"
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M89.147 57.1445H21.4972C20.8044 57.1445 20.2428 57.7083 20.2428 58.4037V59.8485C20.2428 60.5439 20.8044 61.1076 21.4972 61.1076H89.147C89.8398 61.1076 90.4014 60.5439 90.4014 59.8485V58.4037C90.4014 57.7083 89.8398 57.1445 89.147 57.1445Z",
    fill: "url(#paint14_linear_5805_191520)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5805_191520",
    x1: 46.1744,
    y1: 102.978,
    x2: 64.5854,
    y2: 102.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5805_191520",
    x1: 47.1108,
    y1: 100.884,
    x2: 47.1108,
    y2: 103.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5805_191520",
    x1: 19,
    y1: 107.713,
    x2: 19.5822,
    y2: 110.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5805_191520",
    x1: 63.3254,
    y1: 97.4196,
    x2: 63.3254,
    y2: 99.8276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5805_191520",
    x1: 63.3253,
    y1: 104.249,
    x2: 63.3253,
    y2: 106.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5805_191520",
    x1: 21.7747,
    y1: 77.2268,
    x2: 88.7886,
    y2: 77.2268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5805_191520",
    x1: 34.7983,
    y1: 27.9721,
    x2: 42.2205,
    y2: 27.9721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5805_191520",
    x1: 69.3891,
    y1: 8,
    x2: 76.8055,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5805_191520",
    x1: 34.7983,
    y1: 38.2715,
    x2: 42.2205,
    y2: 38.2715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5805_191520",
    x1: 69.4122,
    y1: 7.99997,
    x2: 76.8287,
    y2: 7.99997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5805_191520",
    x1: 21.5696,
    y1: 50.2829,
    x2: 89.2769,
    y2: 50.2829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5805_191520",
    x1: 55.5373,
    y1: 11.3159,
    x2: 55.5373,
    y2: 42.5633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5805_191520",
    x1: 57.4407,
    y1: 59.3204,
    x2: 57.4407,
    y2: 68.8075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5805_191520",
    x1: 50.6908,
    y1: 49.7474,
    x2: 33.8379,
    y2: 49.7474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5805_191520",
    x1: 20.2428,
    y1: 59.1232,
    x2: 90.4014,
    y2: 59.1232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5805_191520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcPlug);
export default __webpack_public_path__ + "static/media/ac_plug.a66c2294f59e486393fa39e7a7359a7f.svg";
export { ForwardRef as ReactComponent };